export default "__VITE_ASSET__Ybc4NWx5__"